import "./common.js";
import "../translations.js";
import "../portico/header.js";
import "../../styles/portico/portico-styles.scss";
